import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ButtonComponent } from '@abook-ui/components/button/button.component';

@Component({
  selector: 'app-login-required-dialog',
  imports: [MatDialogModule, ButtonComponent],
  templateUrl: './login-required-dialog.component.html',
  styleUrl: './login-required-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginRequiredDialogComponent {
  private dialogRef = inject(MatDialogRef<LoginRequiredDialogComponent>);
  private auth = inject(AuthenticationService);
  private router = inject(Router);
  private data = inject<{ returnUrl: string }>(MAT_DIALOG_DATA, { optional: true });

  protected signIn(): void {
    this.dialogRef.close();
    this.auth.signIn(this.data?.returnUrl);
  }

  protected register(): void {
    this.dialogRef.close();
    const extras = this.data?.returnUrl ? { queryParams: { returnUrl: this.data.returnUrl } } : {};
    this.router.navigate(['/account/create'], extras);
  }

  protected cancel(): void {
    this.dialogRef.close();
  }
}
